import { Box, Button, Tooltip } from '@mui/material';
import React from 'react';
import I18n from '../i18n/I18n';

const NEW_TAB_BUTTON_SX = {
    minHeight: 36,
    height: 36,
    px: 1.5,
    fontSize: 'button.fontSize',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    flexShrink: 0
} as const;

const ACTIVE_NEW_TAB_BUTTON_SX = {
    ...NEW_TAB_BUTTON_SX,
    fontStyle: 'italic'
} as const;

type NewTabCtaProps = {
    disabled: boolean;
    tooltipToken: string | null;
    onClick: () => void;
};

export default function NewTabCta({ disabled, tooltipToken, onClick }: NewTabCtaProps) {
    const button = (
        <Button
            data-testid="pinned-filter-tab-new"
            disabled={disabled}
            onClick={onClick}
            sx={disabled ? NEW_TAB_BUTTON_SX : ACTIVE_NEW_TAB_BUTTON_SX}
        >
            <I18n token="filter.savedFilter.addTab" />
        </Button>
    );

    if (!tooltipToken) {
        return button;
    }

    return (
        <Tooltip title={<I18n token={tooltipToken} />}>
            <Box component="span" sx={{ display: 'inline-flex' }}>
                {button}
            </Box>
        </Tooltip>
    );
}
